export default __webpack_public_path__ + "static/media/search-white.8e25ae7e.svg";